module.exports = __webpack_public_path__ + "media/images/favicon/favicon-32x32-0a676ee12970afc2adbfb1403a541359.png";